export default __webpack_public_path__ + "static/media/cups-helper.201f58cd.png";